import { Report } from 'notiflix/build/notiflix-report-aio'
import { Loading } from 'notiflix'

const KNOWN_SERVER_ERRORS = [
    'token not found',
    'no token',
    'Token not found',
    'Consented previously',
    'FOA V2 Signed',
    'FOA Complete',
    'all CFAs Complete',
    'EX160 Complete',
    'POC Complete',
    'Lead is duplicate',
]

export const apiErrors = (serverError: string) => {
    if (serverError === 'token not found' || serverError === 'no token' || serverError === 'Token not found') {
        Report.failure(
            'Unable to locate account.',
            'We were unable to locate your case, contact support@sentinellegal.co.uk for more information.',
            'OK',
            () => {
                window.location.href = 'https://sentinellegal.co.uk'
            }
        )
    }

    if (serverError === 'Consented previously') {
        Report.success(
            'Already Consented',
            'We have already received your consent. Armalytix will contact you shortly. ',
            'OK',
            () => {
                window.location.href = 'https://sentinellegal.co.uk'
            }
        )
    }
    if (serverError === 'FOA V2 Signed') {
        Report.success('FOA Complete', 'Your FOA has already been completed.', 'OK', () => {
            window.location.href = 'https://sentinellegal.co.uk'
        })
    }
    if (serverError === 'FOA Complete') {
        Report.success('FOA Complete', 'Your FOA has already been completed.', 'OK', () => {
            window.location.href = 'https://sentinellegal.co.uk'
        })
    }
    if (serverError === 'all CFAs Complete') {
        Report.success('No Documents Available', "You don't have any documents to sign.", 'Okay', () => {
            window.location.href = 'https://sentinellegal.co.uk'
        })
    }
    if (serverError === 'EX160 Complete') {
        Report.success('EX160 Complete', 'Your EX160 has already been completed.', 'OK', () => {
            window.location.href = 'https://sentinellegal.co.uk'
        })
    }
    if (serverError === 'POC Complete') {
        Report.success('Documents signed', 'Your PoC and N1 documents have already been completed.', 'OK', () => {
            window.location.href = 'https://sentinellegal.co.uk'
        })
    }
    if (serverError === 'Lead is duplicate') {
        Report.info(
            'Unaccepted',
            'It looks like we already have your details. We only require one submission per client.',
            'OK',
            () => {
                window.location.href = 'https://sentinellegal.co.uk'
            }
        )
    }
    if (serverError.includes('SD Bad Request')) {
        Report.info(
            'Contact Sanderson Drake',
            'Sanderson Drake have not been able to provide your case details. Please contact them directly.',
            'OK',
            () => {
                window.location.href = 'https://sentinellegal.co.uk'
            }
        )
    }

    if (!KNOWN_SERVER_ERRORS.includes(serverError) && !serverError.includes('SD Bad Request')) {
        Report.failure(
            'Internal Error',
            "We've encountered an internal error, please try again later.",
            'OK',
            () => {
                // noop
            }
        )
    }

    return true
}
